import request from '@/utils/request'

// 获取视频流地址
export function getVideoStream (params) {
  return request({
    url: '/wms/ezviz/video_stream/',
    method: 'get',
    params
  })
}
